import { createStructuredSelector } from 'reselect'

import {
  SEARCH_REQUEST_TYPE,
  SEARCH_REQUEST_TYPE_SUCCESS,
  SEARCH_REQUEST_TYPE_ERROR,
  SEARCH_EQUIPMENT_DELIVERY_ORDER,
  SEARCH_EQUIPMENT_DELIVERY_ORDER_SUCCESS,
  SEARCH_EQUIPMENT_DELIVERY_ORDER_ERROR,
  SEARCH_DELIVERY_ORDER_LINE_LOT,
  SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS,
  SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR,
  SEARCH_PRIORITY,
  SEARCH_PRIORITY_SUCCESS,
  SEARCH_PRIORITY_ERROR,
  SEARCH_REQUEST_STATUS,
  SEARCH_REQUEST_STATUS_SUCCESS,
  SEARCH_REQUEST_STATUS_ERROR,
  SEARCH_REQUEST_TYPE_DETAIL,
  SEARCH_REQUEST_TYPE_DETAIL_SUCCESS,
  SEARCH_REQUEST_TYPE_DETAIL_ERROR,
  SEARCH_HOSPITAL_SECTION,
  SEARCH_HOSPITAL_SECTION_SUCCESS,
  SEARCH_HOSPITAL_SECTION_ERROR,
  SEARCH_HOSPITAL_SERVICE,
  SEARCH_HOSPITAL_SERVICE_SUCCESS,
  SEARCH_HOSPITAL_SERVICE_ERROR,
  SEARCH_QUOTE_EXPIRATION,
  SEARCH_QUOTE_EXPIRATION_SUCCESS,
  SEARCH_QUOTE_EXPIRATION_ERROR,
  SEARCH_INCOTERM,
  SEARCH_INCOTERM_SUCCESS,
  SEARCH_INCOTERM_ERROR,
  SEARCH_TRANSPORT_TYPE,
  SEARCH_TRANSPORT_TYPE_SUCCESS,
  SEARCH_TRANSPORT_TYPE_ERROR,
  SEARCH_FILE_TYPE,
  SEARCH_FILE_TYPE_SUCCESS,
  SEARCH_FILE_TYPE_ERROR,
  SEARCH_REQUEST_PROCESS_TYPE,
  SEARCH_REQUEST_PROCESS_TYPE_SUCCESS,
  SEARCH_REQUEST_PROCESS_TYPE_ERROR,
  SEARCH_REQUEST_ARTICLE_TYPE,
  SEARCH_REQUEST_ARTICLE_TYPE_SUCCESS,
  SEARCH_REQUEST_ARTICLE_TYPE_ERROR,
  SEARCH_HEALTH_REGISTRY_AGENCY,
  SEARCH_HEALTH_REGISTRY_AGENCY_SUCCESS,
  SEARCH_HEALTH_REGISTRY_AGENCY_ERROR,
  SEARCH_BMP_AGENCY,
  SEARCH_BMP_AGENCY_SUCCESS,
  SEARCH_BMP_AGENCY_ERROR,
  SEARCH_RISK_TYPE,
  SEARCH_RISK_TYPE_SUCCESS,
  SEARCH_RISK_TYPE_ERROR,
  SEARCH_GHTF,
  SEARCH_GHTF_SUCCESS,
  SEARCH_GHTF_ERROR,
  SEARCH_DIAGNOSTIC_CLASS,
  SEARCH_DIAGNOSTIC_CLASS_SUCCESS,
  SEARCH_DIAGNOSTIC_CLASS_ERROR,
  SEARCH_ISO,
  SEARCH_ISO_SUCCESS,
  SEARCH_ISO_ERROR,
  SEARCH_GT_CERTIFICATE,
  SEARCH_GT_CERTIFICATE_SUCCESS,
  SEARCH_GT_CERTIFICATE_ERROR,
  SEARCH_SERVICE_TYPE,
  SEARCH_SERVICE_TYPE_SUCCESS,
  SEARCH_SERVICE_TYPE_ERROR,
  SEARCH_BIOEQUIVALENCE,
  SEARCH_BIOEQUIVALENCE_SUCCESS,
  SEARCH_BIOEQUIVALENCE_ERROR
} from '../actions';

export const NAME = 'search';


export const SearchRequestType = (data) => ({
  type: SEARCH_REQUEST_TYPE,
  payload: data
});

export const SearchRequestTypeSuccess = (data) => ({
  type: SEARCH_REQUEST_TYPE_SUCCESS,
  payload: data
});

export const SearchRequestTypeError = (error) => ({
  type: SEARCH_REQUEST_TYPE_ERROR,
  payload: error
});

export const SearchEquipmentDeliveryOrder = (data) => ({
  type: SEARCH_EQUIPMENT_DELIVERY_ORDER,
  payload: data
});

export const SearchEquipmentDeliveryOrderSuccess = (data) => ({
  type: SEARCH_EQUIPMENT_DELIVERY_ORDER_SUCCESS,
  payload: data
});

export const SearchEquipmentDeliveryOrderError = (error) => ({
  type: SEARCH_EQUIPMENT_DELIVERY_ORDER_ERROR,
  payload: error
});

export const SearchDeliveryOrderLineLot = (data) => ({
  type: SEARCH_DELIVERY_ORDER_LINE_LOT,
  payload: data
});

export const SearchDeliveryOrderLineLotSuccess = (data) => ({
  type: SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS,
  payload: data
});

export const SearchDeliveryOrderLineLotError = (error) => ({
  type: SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR,
  payload: error
});

export const SearchPriority = (data) => ({
  type: SEARCH_PRIORITY,
  payload: data
});

export const SearchPrioritySuccess = (data) => ({
  type: SEARCH_PRIORITY_SUCCESS,
  payload: data
});

export const SearchPriorityError = (error) => ({
  type: SEARCH_PRIORITY_ERROR,
  payload: error
});

export const SearchRequestStatus = (filters) => ({
  type: SEARCH_REQUEST_STATUS,
  payload: {filters: filters}
}); 

export const SearchRequestStatusSuccess = (data) => ({
  type: SEARCH_REQUEST_STATUS_SUCCESS,
  payload: data
});

export const SearchRequestStatusError = (error) => ({
  type: SEARCH_REQUEST_STATUS_ERROR,
  payload: error
});

export const SearchRequestTypeDetail = () => ({
  type: SEARCH_REQUEST_TYPE_DETAIL
});

export const SearchRequestTypeDetailSuccess = (data) => ({
  type: SEARCH_REQUEST_TYPE_DETAIL_SUCCESS,
  payload: data
});

export const SearchRequestTypeDetailError = (error) => ({
  type: SEARCH_REQUEST_TYPE_DETAIL_ERROR,
  payload: error
});

export const SearchHospitalService = () => ({
  type: SEARCH_HOSPITAL_SERVICE
});

export const SearchHospitalServiceSuccess = (data) => ({
  type: SEARCH_HOSPITAL_SERVICE_SUCCESS,
  payload: data
});

export const SearchHospitalServiceError = (error) => ({
  type: SEARCH_HOSPITAL_SERVICE_ERROR,
  payload: error
});

export const SearchHospitalSection = (filters) => ({
  type: SEARCH_HOSPITAL_SECTION,
  payload: {filters: filters}
});

export const SearchHospitalSectionSuccess = (data) => ({
  type: SEARCH_HOSPITAL_SECTION_SUCCESS,
  payload: data
});

export const SearchHospitalSectionError = (error) => ({
  type: SEARCH_HOSPITAL_SECTION_ERROR,
  payload: error
});

export const SearchQuoteExpiration = () => ({
  type: SEARCH_QUOTE_EXPIRATION
});

export const SearchQuoteExpirationSuccess = (data) => ({
  type: SEARCH_QUOTE_EXPIRATION_SUCCESS,
  payload: data
});

export const SearchQuoteExpirationError = (error) => ({
  type: SEARCH_QUOTE_EXPIRATION_ERROR,
  payload: error
});

export const SearchIncoterm = () => ({
  type: SEARCH_INCOTERM
});

export const SearchIncotermSuccess = (data) => ({
  type: SEARCH_INCOTERM_SUCCESS,
  payload: data
});

export const SearchIncotermError = (error) => ({
  type: SEARCH_INCOTERM_ERROR,
  payload: error
});

export const SearchTransportType = () => ({
  type: SEARCH_TRANSPORT_TYPE
});

export const SearchTransportTypeSuccess = (data) => ({
  type: SEARCH_TRANSPORT_TYPE_SUCCESS,
  payload: data
});

export const SearchTransportTypeError = (error) => ({
  type: SEARCH_TRANSPORT_TYPE_ERROR,
  payload: error
});

export const SearchFileType = (data) => ({
  type: SEARCH_FILE_TYPE,
  payload: data
});

export const SearchFileTypeSuccess = (data) => ({
  type: SEARCH_FILE_TYPE_SUCCESS,
  payload: data
});

export const SearchFileTypeError = (error) => ({
  type: SEARCH_FILE_TYPE_ERROR,
  payload: error
});

export const SearchRequestProcessType = (data) => ({
  type: SEARCH_REQUEST_PROCESS_TYPE,
  payload: data
});

export const SearchRequestProcessTypeSuccess = (data) => ({
  type: SEARCH_REQUEST_PROCESS_TYPE_SUCCESS,
  payload: data
});

export const SearchRequestProcessTypeError = (error) => ({
  type: SEARCH_REQUEST_PROCESS_TYPE_ERROR,
  payload: error
});

export const SearchRequestArticleType = (data) => ({
  type: SEARCH_REQUEST_ARTICLE_TYPE,
  payload: data
});

export const SearchRequestArticleTypeSuccess = (data) => ({
  type: SEARCH_REQUEST_ARTICLE_TYPE_SUCCESS,
  payload: data
});

export const SearchRequestArticleTypeError = (error) => ({
  type: SEARCH_REQUEST_ARTICLE_TYPE_ERROR,
  payload: error
});

export const SearchHealthRegistryAgency = (data) => ({
  type: SEARCH_HEALTH_REGISTRY_AGENCY,
  payload: data
});

export const SearchHealthRegistryAgencySuccess = (data) => ({
  type: SEARCH_HEALTH_REGISTRY_AGENCY_SUCCESS,
  payload: data
});

export const SearchHealthRegistryAgencyError = (error) => ({
  type: SEARCH_HEALTH_REGISTRY_AGENCY_ERROR,
  payload: error
});

export const SearchBmpAgency = (data) => ({
  type: SEARCH_BMP_AGENCY,
  payload: data
});

export const SearchBmpAgencySuccess = (data) => ({
  type: SEARCH_BMP_AGENCY_SUCCESS,
  payload: data
});

export const SearchBmpAgencyError = (error) => ({
  type: SEARCH_BMP_AGENCY_ERROR,
  payload: error
});

export const SearchRiskType = (data) => ({
  type: SEARCH_RISK_TYPE,
  payload: data
});

export const SearchRiskTypeSuccess = (data) => ({
  type: SEARCH_RISK_TYPE_SUCCESS,
  payload: data
});

export const SearchRiskTypeError = (error) => ({
  type: SEARCH_RISK_TYPE_ERROR,
  payload: error
});

export const SearchGhtf = (data) => ({
  type: SEARCH_GHTF,
  payload: data
});

export const SearchGhtfSuccess = (data) => ({
  type: SEARCH_GHTF_SUCCESS,
  payload: data
});

export const SearchGhtfError = (error) => ({
  type: SEARCH_GHTF_ERROR,
  payload: error
});

export const SearchDiagnosticClass = (data) => ({
  type: SEARCH_DIAGNOSTIC_CLASS,
  payload: data
});

export const SearchDiagnosticClassSuccess = (data) => ({
  type: SEARCH_DIAGNOSTIC_CLASS_SUCCESS,
  payload: data
});

export const SearchDiagnosticClassError = (error) => ({
  type: SEARCH_DIAGNOSTIC_CLASS_ERROR,
  payload: error
});

export const SearchIso = (data) => ({
  type: SEARCH_ISO,
  payload: data
});

export const SearchIsoSuccess = (data) => ({
  type: SEARCH_ISO_SUCCESS,
  payload: data
});

export const SearchIsoError = (error) => ({
  type: SEARCH_ISO_ERROR,
  payload: error
});

export const SearchGtCertificate = (data) => ({
  type: SEARCH_GT_CERTIFICATE,
  payload: data
});

export const SearchGtCertificateSuccess = (data) => ({
  type: SEARCH_GT_CERTIFICATE_SUCCESS,
  payload: data
});

export const SearchGtCertificateError = (error) => ({
  type: SEARCH_GT_CERTIFICATE_ERROR,
  payload: error
});

export const SearchServiceType = (data) => ({
  type: SEARCH_SERVICE_TYPE,
  payload: data
});

export const SearchServiceTypeSuccess = (data) => ({
  type: SEARCH_SERVICE_TYPE_SUCCESS,
  payload: data
});

export const SearchServiceTypeError = (error) => ({
  type: SEARCH_SERVICE_TYPE_ERROR,
  payload: error
});

export const SearchBioequivalence = (data) => ({
  type: SEARCH_BIOEQUIVALENCE,
  payload: data
});

export const SearchBioequivalenceSuccess = (data) => ({
  type: SEARCH_BIOEQUIVALENCE_SUCCESS,
  payload: data
});

export const SearchBioequivalenceError = (error) => ({
  type: SEARCH_BIOEQUIVALENCE_ERROR,
  payload: error
});

const search = (state) => state[NAME];

export const SearchSelector = createStructuredSelector({
  search
})
